var path = '/templates/zenclerk_s/sites/dashboard/dashboard.html';
var html = "<div class=\"container dashboard\"><zcs-dashboard-main project=project></zcs-dashboard-main><zcs-notification-timezone project=project></zcs-notification-timezone></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/dashboard.html
// module id = 1405
// module chunks = 0